var $ = require('jquery');
var Backbone = require('backbone');

var TemplateCache = require('TemplateCache');


var ResultView = Backbone.View.extend({

	events: {
		'click .favable': 'handleFavorite',
		'click .result-box': 'openItem',
	},

	initialize: function() {
		this.rendered = false;
	},

	render: function() {
		var favorites = TraminoFavoriten.getItemsMap();
		this.fav_key = 'clients-' + this.model.get("id");

		this.el.innerHTML = TemplateCache.render('ResultTemplate', {
			result: this.model.toJSON(),
			favorited: (typeof favorites[this.fav_key] !== "undefined"),
		});

		this.rendered = true;
	},

	hide: function() {
		this.$el.detach();
	},

	show: function($list) {
		this.$el.appendTo($list);
	},

	openItem: function(e) {
		/* Nicht bei den Arrows triggern */
		if ( e.target.className.indexOf('favable') !== -1 ) return;
		e.preventDefault();
		window.open(this.$el.find('a').attr('href'));
	},

	handleFavorite: function(e) {
		var items = TraminoFavoriten.getItemsMap();
		if ( typeof items[this.fav_key] === "undefined" ) {
			TraminoFavoriten.add({id: this.fav_key});
		} else {
			TraminoFavoriten.remove(this.fav_key);
		}
	},

	/* Create a copy of this view (needed for Google Maps) */
	clone: function() {
		var view = new ResultView({
			model: this.model,
		});
		return view;
	},

});

module.exports = ResultView;



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/reserva/browser/views/ResultView.js
 **/